var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "modal fade",
        { show: _vm.getIsShowPopupLogin, "d-block": _vm.getIsShowPopupLogin },
      ],
      style: { display: _vm.getIsShowPopupLogin ? "block" : "none" },
      attrs: { id: "go-modal-member", tabindex: "-1" },
    },
    [
      _c("div", { staticClass: "modal-dialog go-modal-member" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("div", { staticClass: "modal-title" }, [
              _vm._v(_vm._s(_vm.$t("login.form.login"))),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn go-btn-icon close",
                attrs: {
                  id: "buttonClosePopupLogin",
                  type: "button",
                  "data-dismiss": "modal",
                },
                on: { click: _vm.handleClosePopupLogin },
              },
              [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _c("div", { staticClass: "go-form-member go-form-login" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "go-form-body" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", {
                    staticClass: "go-form-label",
                    domProps: { textContent: _vm._s(_vm.$t("login.form.id")) },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "go-input-group" }, [
                    _vm.isPhone
                      ? _c("div", { staticClass: "go-input-group country" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.countrySelect,
                                  expression: "countrySelect",
                                },
                              ],
                              staticClass: "go-form-control",
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.countrySelect = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                              },
                            },
                            [
                              _c(
                                "option",
                                {
                                  attrs: { disabled: "", selected: "" },
                                  domProps: { value: null },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "myPage.profile.selectPhoneCountry"
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.countries, function (country) {
                                return _c(
                                  "option",
                                  {
                                    key: country.label,
                                    domProps: { value: country.value },
                                  },
                                  [_vm._v(_vm._s(country.label))]
                                )
                              }),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm.mailOrPhoneTxt &&
                          _vm.mailOrPhoneTxt.length > 0 &&
                          _vm.countrySelect === null
                            ? _c(
                                "small",
                                { staticClass: "form-text text-danger" },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t(
                                          "myPage.profile.requiredPhoneCountry"
                                        )
                                      ) +
                                      "\n                  "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.mailOrPhoneTxt,
                          expression: "mailOrPhoneTxt",
                        },
                      ],
                      staticClass: "go-form-control",
                      attrs: {
                        type: "text",
                        placeholder: _vm.$t("login.form.enterPhoneOrMail"),
                        maxlength: "40",
                        disabled: _vm.isSendingCode,
                      },
                      domProps: { value: _vm.mailOrPhoneTxt },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.mailOrPhoneTxt = $event.target.value
                          },
                          _vm.checkRegex,
                        ],
                        keydown: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          return _vm.getVerificationCode()
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "go-input-group-append" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn go-btn-outline-primary",
                          staticStyle: {
                            display: "flex",
                            "justify-content": "center",
                          },
                          attrs: {
                            type: "button",
                            disabled:
                              _vm.mailOrPhoneTxt.length < 5 ||
                              _vm.isInvalidMailOrPhone ||
                              _vm.isSendingCode,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.getVerificationCode()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$t("login.form.verifyPhone")) +
                              "\n                  "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.isShowResendCode
                    ? _c("div", { staticClass: "go-form-feedback" }, [
                        _c("div", {
                          staticClass: "go-form-feedback-valid",
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("login.form.codeSended")
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "go-form-feedback-help" }, [
                          _vm._v(_vm._s(_vm.$t("login.form.didntReceiveCode"))),
                          _c("a", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("login.form.resendCode")
                              ),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.resendCode()
                              },
                            },
                          }),
                        ]),
                      ])
                    : _c("div", { staticClass: "go-form-feedback" }, [
                        !_vm.mailOrPhoneTxt.length && _vm.isType
                          ? _c("div", {
                              staticClass: "go-form-feedback-invalid",
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("login.form.enterID")
                                ),
                              },
                            })
                          : _vm.isInvalidMailOrPhone
                          ? _c("div", {
                              staticClass: "go-form-feedback-invalid",
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("login.form.invalidId")
                                ),
                              },
                            })
                          : !_vm.existedMailOrPhone
                          ? _c("div", {
                              staticClass: "go-form-feedback-invalid",
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("login.form.notExistID")
                                ),
                              },
                            })
                          : _vm._e(),
                      ]),
                ]),
                _vm._v(" "),
                _vm.isShowResendCode && _vm.existedMailOrPhone
                  ? _c("div", { staticClass: "form-group" }, [
                      _c("label", { staticClass: "go-form-label" }, [
                        _vm._v(_vm._s(_vm.$t("login.form.enterCode"))),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "go-input-group" }, [
                        _c(
                          "div",
                          { staticClass: "go-input-group-floating" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.confirmCode,
                                  expression: "confirmCode",
                                },
                              ],
                              ref: "verifyCode",
                              staticClass: "go-form-control",
                              attrs: {
                                type: "text",
                                placeholder: _vm.$t(
                                  "login.form.pleaseEnterCode"
                                ),
                                maxlength: "6",
                              },
                              domProps: { value: _vm.confirmCode },
                              on: {
                                input: [
                                  function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.confirmCode = $event.target.value
                                  },
                                  _vm.checkRegexCode,
                                ],
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.stopPropagation()
                                  $event.preventDefault()
                                  return _vm.confirm(true)
                                },
                              },
                            }),
                            _vm._v(" "),
                            _vm.isSendingCode
                              ? _c("countdown", {
                                  attrs: {
                                    "left-time": _vm.SEND_CODE_TIMEOUT * 1000,
                                  },
                                  on: { finish: _vm.finishCountdown },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "process",
                                        fn: function (ref) {
                                          var timeObj = ref.timeObj
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "go-form-timer" },
                                              [
                                                _vm._v(
                                                  _vm._s(timeObj.m) +
                                                    ":" +
                                                    _vm._s(
                                                      (
                                                        "" +
                                                        ("0" +
                                                          Math.ceil(
                                                            timeObj.ceil.s % 60
                                                          ))
                                                      ).slice(-2)
                                                    )
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "finish",
                                        fn: function () {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "go-form-timer" },
                                              [_vm._v(_vm._s("00:00"))]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    3393246449
                                  ),
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      !_vm.confirmCode.length
                        ? _c("div", {
                            staticClass: "go-form-feedback-invalid",
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("login.form.pleaseEnterCode2")
                              ),
                            },
                          })
                        : !_vm.checkRegexCode() || _vm.confirmCode.length < 6
                        ? _c("div", {
                            staticClass: "go-form-feedback-invalid",
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("login.form.invalidCode")
                              ),
                            },
                          })
                        : _vm.isExpiredCode
                        ? _c("div", {
                            staticClass: "go-form-feedback-invalid",
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("login.form.expiredCode")
                              ),
                            },
                          })
                        : _vm.isVerificationCodeSuccess
                        ? _c("div", {
                            staticClass: "go-form-feedback-valid",
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("login.form.successVerifiedCode")
                              ),
                            },
                          })
                        : !_vm.isVerificationCodeSuccess &&
                          _vm.sendedVerificationCode
                        ? _c("div", {
                            staticClass: "go-form-feedback-invalid",
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("login.form.invalidCode")
                              ),
                            },
                          })
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "go-block-between" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "custom-control custom-checkbox custom-control-inline",
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.rememberMe,
                            expression: "rememberMe",
                          },
                        ],
                        staticClass: "custom-control-input",
                        attrs: { type: "checkbox", id: "customCheckDisabled1" },
                        domProps: {
                          checked: Array.isArray(_vm.rememberMe)
                            ? _vm._i(_vm.rememberMe, null) > -1
                            : _vm.rememberMe,
                        },
                        on: {
                          click: function ($event) {
                            _vm.rememberMe = !_vm.rememberMe
                          },
                          change: function ($event) {
                            var $$a = _vm.rememberMe,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.rememberMe = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.rememberMe = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.rememberMe = $$c
                            }
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "custom-control-label",
                          attrs: { for: "customCheckDisabled1" },
                        },
                        [_vm._v(_vm._s(_vm.$t("login.form.autoLogin")))]
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "go-btn-block" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-login",
                      attrs: {
                        type: "submit",
                        disabled:
                          !_vm.isSendingCode ||
                          !_vm.checkRegexCode() ||
                          _vm.confirmCode.length < 6 ||
                          (!_vm.isVerificationCodeSuccess &&
                            _vm.sendedVerificationCode) ||
                          (_vm.minLeft === "00" && _vm.secLeft === "00") ||
                          _vm.waitingLoginApi,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.confirm(true)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("login.form.button")) +
                          "\n                "
                      ),
                      _vm.waitingLoginApi
                        ? _c("b-spinner", {
                            staticStyle: { "margin-left": "10px" },
                            attrs: { small: "", label: "Small Spinner" },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("hr", { staticClass: "hr-2" }),
                _vm._v(" "),
                _c("div", { staticClass: "go-block-between" }, [
                  _c("p", [_vm._v(_vm._s(_vm.$t("login.form.notAMember")))]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-outline-primary",
                      attrs: { type: "button" },
                      on: { click: _vm.handleOpenPopupRegister },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("login.form.join")) +
                          "\n              "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "go-form-header" }, [
      _c("div", { staticClass: "go-brand" }, [
        _c("div", { staticClass: "go-brand-logo" }, [
          _c("img", {
            attrs: {
              src: "content/images/images_v3/common/goover_logo.png",
              alt: "goover logo",
            },
          }),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }